<button
  [type]="type"
  [disabled]="disabled"
  [ngClass]="{
    'main-btn': btnStyle === 'main',
    'main-btn-outlined': btnVariant === 'outlined',
    'main-btn-filled': btnVariant === 'filled',
    'second-btn': btnStyle === 'second',
    'clear-btn': btnStyle === 'clear',
    'small-btn': size === 'small',
    disabled: disabled,
    'md:gap-5': size === 'normal',
  }"
  [pTooltip]="tooltipTitle"
  [tooltipPosition]="tooltipPosition"
  [routerLink]="routerLink"
  class="flex flex-row items-center gap-2"
  [class]="styleClass"
  (click)="onClickEvent($event)"
>
  @if (text) {
    <span>{{ text }}</span>
  }
  @if (icon) {
    <i class="pointer-events-none" [ngClass]="'pi pi-' + icon"></i>
  }
  <ng-content></ng-content>
</button>
